/**
 * Full-page fallback for when Clerk's client never finished loading
 * (see useClerkReady). The overwhelmingly common cause is the network
 * blocking the connection to clerk.<domain> — a firewall doing TLS
 * inspection (corporate or public/airport wifi), a VPN, CSP, or a Clerk
 * outage — rather than anything wrong with the user's account. We say so
 * plainly and give them a retry path instead of an infinite spinner.
 */

export default function AuthUnavailable() {
  return (
    <div className="card" style={{ maxWidth: 480, margin: '2rem auto' }}>
      <h1>Can’t reach sign-in</h1>
      <p className="muted">
        We couldn’t load our sign-in service. This is almost always a network
        issue — a firewall or VPN (common on corporate and public/airport wifi)
        blocking the connection — not a problem with your account.
      </p>
      <p className="muted">
        Try a different network, such as your phone’s hotspot, then retry.
      </p>
      <button type="button" className="primary" onClick={() => window.location.reload()}>
        Retry
      </button>
    </div>
  );
}
